import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 35 35"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M9.75 11.125c-.387 0-.687.354-.687.708v1.019l7.39 6.242a2.34 2.34 0 0 0 3.05 0l7.435-6.242v-1.019c0-.354-.344-.708-.688-.708zm-.687 4.471v7.57c0 .4.3.709.687.709h16.5c.344 0 .688-.31.688-.708v-7.57l-6.102 5.135c-1.676 1.416-4.04 1.416-5.672 0zM7 11.833C7 10.283 8.203 9 9.75 9h16.5C27.754 9 29 10.284 29 11.833v11.334C29 24.76 27.754 26 26.25 26H9.75C8.203 26 7 24.76 7 23.167z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }